import initialState from './initialState'

const SET_CUSTOMER_DATA = (state, customerData) => {
    state.customerData = customerData
}

const SET_CUSTOMER_ID = (state, customerID) => {
    state.customerID = customerID
}

const SET_DATA_STATUS = (state, dataStatus) => {
    state.dataStatus = dataStatus
}

const TOGGLE_CREATE_MODE = (state, bool) => {
    state.createMode = bool
}

const SET_CLIENT_DISCOUNT = function(state, percentage) {
    state.clientDiscount = percentage
}

const SET_AVAILABLE_DISCOUNTS = (state, discountsArray) => {
    state.availableDiscounts = discountsArray
}

const SET_ACTIVE_OFFICE = (state, office) => {
    state.activeOfficeID = office
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = state => {
    Object.assign(state, initialState())
}

export default {
    RESET_STATE,
    SET_CUSTOMER_DATA,
    SET_DATA_STATUS,
    TOGGLE_CREATE_MODE,
    SET_CUSTOMER_ID,
    SET_AVAILABLE_DISCOUNTS,
    SET_CLIENT_DISCOUNT,
    SET_ACTIVE_OFFICE,
}
